// #2835 — NFR status display strings.
//
// NEEDS_BUSINESS_DECISION_LABEL is the one canonical wording for that status:
// the disposition option, the proposal label and the resolved-note prefix
// all use it, and the badge (below) reads the same words in capitals.
// ProjectMemberDashboard's "Waiting on business decision" is a deliberate
// owner's-view variant of it, not a drift: see the comment there.
export const NEEDS_BUSINESS_DECISION_LABEL = 'Needs business decision';

/** Badge text for an NFR status: the enum with EVERY underscore replaced.
 *  Before #2835 the badge used `status.replace('_', ' ')`, which replaces
 *  only the first one; that was fine while no status had two underscores,
 *  and would have rendered NEEDS_BUSINESS_DECISION as
 *  "NEEDS BUSINESS_DECISION". Works for a status this bundle doesn't know
 *  yet, too. */
export function nfrStatusBadgeText(status: string): string {
  return status.split('_').join(' ');
}

// #2835 deploy 1 — sent on every apiFetch call so the API can tell this
// bundle (which understands NEEDS_BUSINESS_DECISION) from a tab loaded
// before the deploy (which doesn't, and gets the legacy value instead). Must
// match NFR_STATUS_VERSION_HEADER / NFR_STATUS_VERSION in
// apps/api/src/db/schema/nfr-legacy-compat.ts. Removed with that file in
// 0235's PR.
export const NFR_STATUS_VERSION_HEADER = 'X-Nfr-Status-Version';
export const NFR_STATUS_VERSION = '2';

// #2761 / #2834 (founder decisions) — NEEDS_BUSINESS_DECISION NFRs stay in an
// owner's assigned-work list (they're still the owner's item) but are
// labelled, because the owner can't act on them yet: NfrsPage only offers the
// disposition action for status 'GAP'. The label keeps the list honest about
// what's expected of the owner right now.
//
// #2835 (founder decision) — the label reads "Waiting on business decision",
// NOT the canonical NEEDS_BUSINESS_DECISION_LABEL above. That is deliberate:
// these lists are the owner's view, and from there the item is waiting on
// someone else, whereas the canonical string describes the item itself. Keep
// the two distinct; if you're aligning copy, don't "fix" this one to match.
//
// Shared by the Business-tier "Assigned to you" list (ProjectMemberDashboard,
// #2761) and the Delivery-tier Workbasket (#2834) so the rule and the wording
// can't drift apart.
export const WAITING_ON_BUSINESS_DECISION_LABEL = 'Waiting on business decision';

export function isWaitingOnBusinessDecision(item: { sourceType: string; status?: string | null }): boolean {
  return item.sourceType === 'NFR' && item.status === 'NEEDS_BUSINESS_DECISION';
}
